module.exports = __webpack_public_path__ + "static/media/03.634b94f5.png";